import * as React from "react";
import { useBloomreachPdpContent } from "@grandvisionhq/bloomreach";
import { useProductWithAFrameData, ProductImage } from "@grandvisionhq/fun-products";
import { RxConfiguratorSlotsProvider, RxGlassesConfigurator } from "@grandvisionhq/fun-rx-configurator";
const RxGlassesConfiguratorGraphContainer = ({
  onModalClose,
  id,
  isOpen,
  opticianForm
}) => {
  const { activeVariant } = useProductWithAFrameData();
  const { configuratorDocument } = useBloomreachPdpContent();
  return /* @__PURE__ */ React.createElement(RxConfiguratorSlotsProvider, { slots: { ProductImage } }, /* @__PURE__ */ React.createElement(
    RxGlassesConfigurator,
    {
      id,
      onModalClose,
      isOpen,
      frameSlug: activeVariant.slug,
      frameSku: activeVariant.sku,
      opticianForm,
      configuratorDocument
    }
  ));
};
export {
  RxGlassesConfiguratorGraphContainer
};
//# sourceMappingURL=RxGlassesConfiguratorGraphContainer.js.map
